import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _FinishedContracts, _TaxHoldValue } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { TaxHoldValueEditor } from "./TaxHoldValueEditor";
import { AccountEditor } from "../../../editor/AccountEditor";



export const TaxHoldValue = () => {

    const TaxHoldValue = useDataBean(_TaxHoldValue);
    const single = Singleton.getInstance();
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [type, settype] = useState<number>(0)
    const [lista, setLista] = useState<any>([]);
    const [funcionario, setFuncionario] = useState<number>(null);
    const [month, setmonth] = useState<number>(null)
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();


    const getLista = () => {

        TaxHoldValue.instance.getTaxHoldValueByEmployee(funcionario, type, year, month).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        TaxHoldValue.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        TaxHoldValue.deleteItemVoid(TaxHoldValue.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        TaxHoldValue.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'Literal', property: 'Mnemonic', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Concepto', property: 'TaxHoldName', visible: true },
        { title: 'Valor (1)', property: 'TaxHoldValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor (2)', property: 'TaxHoldValue2', visible: true, mask: MASK_MONEY },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Retención en la Fuente por Empleado">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-4">
                    <MonthConstantsEditor idSelect={month} onChange={(e) => { setmonth(e) }} label="Mes" name="" />
                </div>
                <div className="col-md-4">
                    <TaxHoldValueEditor label='Tipo de Procedimiento' idSelector={type} onChange={(e) => { settype(e) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={funcionario} onChange={(e) => { setFuncionario(e.IDAccount) }} label="Empleado" />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Consultar
                    </BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={TaxHoldValue.setBean} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {TaxHoldValue.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}